import { FC, MouseEvent, memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { APP_SHOW_RESULT_PAGE_TEXT } from "consts";

type Props = {
  tab: string;
  onChange: (event: MouseEvent<HTMLElement>, newTab: string) => void;
};

const Header: FC<Props> = ({ tab, onChange }) => {
  const { t } = useTranslation();
  const tabs = useMemo(
    () => [
      { value: "data", label: t("Data") },
      { value: "ldc", label: t("LDC") },
      { value: "descr", label: t("Description") },
    ],
    [t],
  );

  return (
    <Stack direction="column">
      <Typography variant="h2" mb="var(--rhythm)">
        {t("Select Results")}
      </Typography>

      <ToggleButtonGroup color="secondary" value={tab} exclusive onChange={onChange}>
        {tabs.map(({ value, label }) => (
          <ToggleButton key={value} color="primary" value={value}>
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      {APP_SHOW_RESULT_PAGE_TEXT && (
        <Alert variant="outlined" severity="info" icon={false} sx={{ mt: "var(--rhythm)" }}>
          <Typography variant="body2">
            {t(
              "The colour temperature used for the calculation is 4000 K. Other options such as 3000 K, 2700 K, 2400 K and others are also available on request. Please contact your responsible sales representative."
            )}
          </Typography>
        </Alert>
      )}
    </Stack>
  );
};

Header.displayName = "Header";

export default memo(Header);
